(() => {
  const normalizeTagValue = (value) => value.trim().replaceAll(',', ' ').replace(/\s+/g, ' ').slice(0, 120);

  document.querySelectorAll('[data-foria-empadronate-form]').forEach((form) => {
    if (form.dataset.foriaEmpadronateReady === 'true') return;
    form.dataset.foriaEmpadronateReady = 'true';

    form.addEventListener('submit', () => {
      const tagsInput = form.querySelector('[data-foria-empadronate-tags]');
      const name = normalizeTagValue(form.querySelector('[data-foria-empadronate-name]')?.value || '');
      const age = normalizeTagValue(form.querySelector('[data-foria-empadronate-age]')?.value || '');
      const town = normalizeTagValue(form.querySelector('[data-foria-empadronate-town]')?.value || '');
      const relationship = normalizeTagValue(
        form.querySelector('[data-foria-empadronate-relationship]:checked')?.value || '',
      );

      if (!tagsInput) return;
      tagsInput.value = [
        'newsletter',
        'Empadronate Foria',
        name && `Nombre: ${name}`,
        age && `Edad: ${age}`,
        town && `Pueblo: ${town}`,
        relationship && `Relacion: ${relationship}`,
      ].filter(Boolean).join(', ');
    });
  });
})();
